// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    border: none;
    border-top: 2px solid rgba(0, 0, 0, 0.1);
    width: -webkit-fit-content;
    width: fit-content;
}

.table-header-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 0.3rem;
}

.table-header {
    padding: 2px 4px;
    position: relative;
    font-weight: bold;
    text-align: center;
    height: 30px;
}

.table-cell {
    border: none;
}

.resizer {
    position: absolute;
    top: 0;
    height: 100%;
    width: 5px;
    background: rgba(0, 0, 0, 0.5);
    cursor: col-resize;
    -webkit-user-select: none;
            user-select: none;
    touch-action: none;
}

.resizer.ltr {
    right: 0;
}

.resizer.rtl {
    left: 0;
}

.resizer.isResizing {
    background: #A046D3;
    opacity: 1;
}

@media (hover: hover) {
    .resizer {
        opacity: 0.2;
    }

    *:hover>.resizer {
        opacity: 1;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/prop-players/prop-player-table.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,wCAAwC;IACxC,0BAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".table-container {\n    border: none;\n    border-top: 2px solid rgba(0, 0, 0, 0.1);\n    width: fit-content;\n}\n\n.table-header-content {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 0.3rem;\n}\n\n.table-header {\n    padding: 2px 4px;\n    position: relative;\n    font-weight: bold;\n    text-align: center;\n    height: 30px;\n}\n\n.table-cell {\n    border: none;\n}\n\n.resizer {\n    position: absolute;\n    top: 0;\n    height: 100%;\n    width: 5px;\n    background: rgba(0, 0, 0, 0.5);\n    cursor: col-resize;\n    user-select: none;\n    touch-action: none;\n}\n\n.resizer.ltr {\n    right: 0;\n}\n\n.resizer.rtl {\n    left: 0;\n}\n\n.resizer.isResizing {\n    background: #A046D3;\n    opacity: 1;\n}\n\n@media (hover: hover) {\n    .resizer {\n        opacity: 0.2;\n    }\n\n    *:hover>.resizer {\n        opacity: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
